import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { isCanceledError } from 'src/helper/api';
import { getLuMiConversation } from './api';
import { type LuMiConversationState, transformLuMiSnapshot } from './types';

const extractSrId = (action: { meta?: { arg?: unknown } }): string => {
  const arg = action?.meta?.arg as Record<string, unknown> | undefined;
  return (arg?.serviceRequestId as string) ?? '';
};

const extraReducers = (builder: ActionReducerMapBuilder<LuMiConversationState>) => {
  builder.addCase(getLuMiConversation().pending, (state, action) => {
    const srId = extractSrId(action);
    if (!srId) return;
    state.loading[srId] = true;
    state.errors[srId] = false;
  });

  builder.addCase(getLuMiConversation().fulfilled, (state, action) => {
    const srId = extractSrId(action);
    const payload = action.payload as Record<string, unknown> | undefined;
    if (!srId || !payload) {
      if (srId) state.loading[srId] = false;
      return;
    }

    const snapshotWrapper = (payload.snapshot as Record<string, unknown> | undefined) ?? {};
    const snapshot = (snapshotWrapper.data as Record<string, unknown>) ?? {};
    const serviceRequestUuid = (payload.service_request_uuid as string) ?? srId;
    state.transcripts[srId] = transformLuMiSnapshot(snapshot, serviceRequestUuid);
    state.loading[srId] = false;
    state.errors[srId] = false;
  });

  builder.addCase(getLuMiConversation().rejected, (state, action) => {
    const srId = extractSrId(action);
    if (!srId) return;
    state.loading[srId] = false;
    if (!isCanceledError(action.payload)) {
      state.errors[srId] = true;
    }
  });
};

export default extraReducers;
